var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIgnoreActive = function SvgIgnoreActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#8A8A94",
    rx: 10.435
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m36.609 32.306-3.62-2.868c0-.082.04-.123.04-.205 0-.287-.12-.615-.362-.86-.764-.86-2.252-2.13-2.252-6.35 0-3.156-2.172-5.696-5.148-6.351v-.86c0-.697-.563-1.312-1.247-1.312-.724 0-1.287.615-1.287 1.311v.86c-1.649.37-3.016 1.27-3.942 2.582l-5.831-4.59c-.282-.245-.684-.163-.885.124l-.805 1.024a.62.62 0 0 0 .121.902l23.65 18.641c.28.246.683.164.884-.123l.805-1.024a.62.62 0 0 0-.121-.901m-19.145-8.481c-.362 2.786-1.488 3.81-2.131 4.548-.242.245-.362.573-.322.86 0 .697.482 1.311 1.287 1.311h9.733zm6.556 10.652c1.408 0 2.534-1.147 2.534-2.622h-5.108c0 1.475 1.126 2.622 2.574 2.622"
  })));
};
export default SvgIgnoreActive;